export default {
  ['popup-title']: 'Dear Contestant,',
  ['popup-desc1']: 'The submission phase has now closed, and the judging process is about to commence.',
  ['popup-desc2']:
    'In accordance with the official competition rules, if the same work has been submitted to multiple tracks, only one entry will be retained for review. Thank you for your attention.'
}
